export default "__VITE_ASSET__CW_RRpHc__"